import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TBackButtonClickEventParams } from './_types';

export const backButtonClickEvent = (params: TBackButtonClickEventParams) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.BACK_BUTTON_CLICK,
    params,
  });
};
